// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bamboo-shoot"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5.42176 18.6496C3.44186 16.6697 2.23978 14.5248 1.88623 13.6999C4.01982 11.5663 6.07698 9.8618 8.00021 8.50014C10.7706 6.53867 13.2631 5.28857 15.3057 4.49192C18.8003 3.12896 20.9781 3.09326 20.9781 3.09326C20.9781 3.09326 20.9331 5.83812 19.0156 10.1095C17.5337 13.4105 14.9335 17.6231 10.3715 22.1851C9.54655 21.8316 7.40166 20.6295 5.42176 18.6496Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.2788 21.6502L8.08686 9.00016M8.75012 8.62054L16.3891 9.84688L18.5501 10.063M15.4076 5.00014C15.7155 6.53347 16.1065 8.45778 16.288 9.35014M1.88623 13.6999C2.23978 14.5248 3.44186 16.6697 5.42176 18.6496C7.40166 20.6295 9.54655 21.8316 10.3715 22.1851C20.8367 11.72 20.9781 3.09326 20.9781 3.09326C20.9781 3.09326 18.8003 3.12896 15.3057 4.49192C11.8451 5.84161 7.09324 8.49286 1.88623 13.6999Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BambooShootIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bamboo-shoot',
    ref,
    icon: element,
  },
));

BambooShootIcon.displayName = 'BambooShootIcon';

export default BambooShootIcon;
